import { format } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { ptBR } from 'date-fns/locale/pt-BR';

/**
 * Formats the passed in date and string
 * @param date the date to format
 * @param dateFormat the string to represent the format
 * @param locale the locale to use for formatting (en, pt, es)
 * @returns a formatted date
 */

const localeMap = {
  en: enUS,
  pt: ptBR,
  es: es,
};

export function FormatDate(
  date: Date,
  dateFormat = 'yyyy-MM-dd',
  locale?: 'en' | 'pt' | 'es'
): string {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  if (!isValid(dateObj)) {
    return '';
  }
  return format(dateObj, dateFormat, {
    locale: locale ? localeMap[locale] : undefined,
  });
}

/**
 * Returns the date format string for a given locale
 * @param locale the locale to use (en, pt, es)
 */
export function getDateFormat(locale: 'en' | 'pt' | 'es'): string {
  const localeCode = locale || 'en';
  const parts = new Intl.DateTimeFormat(localeCode)
    .formatToParts(new Date(2020, 11, 31))
    .map((p) => (p.type === 'literal' ? p.value : p.type));
  return parts
    .map((p) => {
      if (p === 'day') return 'dd';
      if (p === 'month') return 'MM';
      if (p === 'year') return 'yyyy';
      return p;
    })
    .join('');
}
